import { ReactNode } from "react";
import styles from "../styles/layout.module.css";

export default function LayoutContainer({ children }: { children: ReactNode }) {
  return <div className={styles.container}>{children}</div>;
}
